import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { GET_PRESIGNED_URL, GET_PRESIGNED_URL_ERROR, GET_PRESIGNED_URL_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getPresignedUrl({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/program/${payload?.params?.id}/presigned`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_PRESIGNED_URL_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PRESIGNED_URL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PRESIGNED_URL_ERROR, payload: error });
  }
}

export function* watchGetPresignedUrl() {
  yield takeEvery(GET_PRESIGNED_URL, getPresignedUrl);
}

function* getPresignedUrlSaga() {
  yield all([fork(watchGetPresignedUrl)]);
}

export default getPresignedUrlSaga;
